// Build a self-contained preview document the SAME way the editor's preview
// iframe does (see NewEditor): the page HTML comes from the `pages` table, the
// CSS/JS are site-level. Relative <link rel="stylesheet"> are stripped (they
// 404 inside a srcDoc iframe — the editor inlines CSS instead), and a permissive
// CSP is injected so inline styles/scripts and external assets load. This keeps
// drafts (no published static files) previewing exactly like the editor shows.
//
// Shared by the full-page SitePreview and the scaled-down thumbnails on the
// admin/client "Sites" grids (SiteThumbPreview).
export const buildPreviewDoc = (html, css = '', js = '') => {
  const rawHtml = (html || '').trim()
  if (!rawHtml) return ''

  try {
    const seed = /<html[\s>]/i.test(rawHtml)
      ? rawHtml
      : `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"></head><body>${rawHtml}</body></html>`
    const parsed = new DOMParser().parseFromString(seed, 'text/html')

    // Strip relative stylesheets — they 404 in srcDoc; site CSS is inlined below.
    parsed.querySelectorAll('link[rel="stylesheet"]').forEach((lnk) => {
      const href = lnk.getAttribute('href') || ''
      if (!href.includes('://')) lnk.remove()
    })

    parsed.head.insertAdjacentHTML(
      'beforeend',
      `<meta http-equiv="Content-Security-Policy" content="default-src * data: blob: 'unsafe-inline' 'unsafe-eval';">` +
        (css ? `<style>${css}</style>` : '')
    )
    if (js) parsed.body.insertAdjacentHTML('beforeend', `<script>try{${js}}catch(e){console.error(e);}<\/script>`)

    return '<!DOCTYPE html>' + parsed.documentElement.outerHTML
  } catch {
    return rawHtml
  }
}

export default buildPreviewDoc
